import i18n from 'config/i18n';
import { Dayjs } from 'dayjs';
import { CostCalculationExternalSurchargeType } from 'generated';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    validFrom: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    validTo: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .test(
        'dayjs-min',
        () =>
          t('dateRangeMismatch', {
            startDate: t('validFrom'),
            endDate: t('validTo')
          }),
        (v, ctx) => {
          const validFrom = ctx.parent.validFrom as Dayjs;
          return v && validFrom ? v.isAfter(validFrom) : true;
        }
      )
      .required(),
    functionId: yup.number().optional().nullable(),
    surchargeType: yup.mixed<CostCalculationExternalSurchargeType>().required(),
    weekdays: yup.object({
      monday: yup.boolean(),
      tuesday: yup.boolean(),
      wednesday: yup.boolean(),
      thursday: yup.boolean(),
      friday: yup.boolean(),
      saturday: yup.boolean(),
      sunday: yup.boolean()
    }),
    timeFrom: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .nullable()
      .required(t('validationFieldRequired', { name: t('timeFrom') })),
    timeTo: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .nullable()
      .required(t('validationFieldRequired', { name: t('timeTo') })),
    amount: yup
      .number()
      .required(t('validationFieldRequired', { name: t('baseAmount') })),
    percentage: yup
      .number()
      .required(t('validationFieldRequired', { name: t('percentage') })),
    description: yup.string().required()
  });
};

export default getSchema;
